
import { computed, defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import AppHeading from "@/components/UI/AppHeading.vue";
import BananoShape from "@/components/UI/BananoShape.vue";
import NewSeed from "@/components/NewSeed.vue";
import { storeUtil } from "@/store";
import { bananoUtil } from "@/util/banano";

export default defineComponent({
  name: "Home",
  props: {
    redirect: {
      type: String,
      required: false,
    },
  },
  components: {
    AppHeading,
    BananoShape,
    NewSeed,
  },

  setup(props) {
    const router = useRouter();
    const route = computed(() => router.currentRoute.value.name);
    const seed = computed(storeUtil.getters.seed);

    const newSeed = () => router.push({ name: "NewSeed" });
    const importSeed = () => router.push({ name: "ImportSeed" });

    const hasSeed = ref(false);
    const encryptedSeed = storeUtil.getters.loadEncryptedSeed() as string;
    if (encryptedSeed) hasSeed.value = true;

    const password = ref("");
    const invalidPassword = ref(false);
    const submitPassword = () => {
      invalidPassword.value = false;

      try {
        const seed = bananoUtil.decryptSeed(encryptedSeed, password.value);
        if (!bananoUtil.isSeedValid(seed)) throw new Error("invalid password");
      } catch {
        invalidPassword.value = true;
        return;
      }

      storeUtil.mutations.loadSeed(password.value);
      storeUtil.mutations.loadAccounts();

      if (props.redirect) {
        router.push(props.redirect);
      } else router.push({ name: "Dashboard" });
    };

    return {
      route,
      seed,
      hasSeed,
      newSeed,
      importSeed,
      password,
      invalidPassword,
      submitPassword,
    };
  },
});
